import { Progress as BaseProgress } from 'antd';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const Progress = styled(BaseProgress).attrs((props) => ({
  className: props.className,
}))`
  & .ant-progress-inner {
    width: 154px;
    height: 24px;
    border-radius: 4px;
    background-color: ${COLOR.LAVENDER_GRAY};
  }

  & .ant-progress-bg {
    border-radius: 0;
    height: 24px !important;
  }
`;
